import React from 'react';
import PropTypes from 'prop-types';

const MatrixToolbar = ({ newName, setNewName, onAdd, disabled }) => (
  <form className="ar-toolbar" onSubmit={onAdd}>
    <div className="ar-input-with-icon">
      <span className="ar-input-with-icon__icon">
        <i className="fas fa-plus" />
      </span>
      <input
        type="text"
        className="ar-input"
        placeholder="Add option for the whole team — e.g. 16+ with valid ID"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
      />
    </div>
    <button
      type="submit"
      className="ar-btn ar-btn--primary"
      disabled={disabled || !newName.trim()}
    >
      Add
    </button>
  </form>
);

MatrixToolbar.propTypes = {
  newName: PropTypes.string.isRequired,
  setNewName: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

MatrixToolbar.defaultProps = {
  disabled: false,
};

export default MatrixToolbar;
